import { Injectable } from '@angular/core';
import { CompanyDto } from '@fleet-beat/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompanyStoreService {
  get timezone(): string | undefined {
    return this.company$.getValue()?.timezone;
  }
  get companyId(): string | undefined {
    return this.company$.getValue()?.id;
  }
  get isUnderZeroSubscription(): boolean {
    return this.company$.getValue()?.price?.amount === 0;
  }
  private company$: BehaviorSubject<CompanyDto> = new BehaviorSubject(undefined);

  setCompany(company: CompanyDto | undefined): void {
    return this.company$.next(company);
  }
  onCompanyReady(): Observable<boolean> {
    return this.company$.asObservable().pipe(map((c: CompanyDto) => !!c));
  }
  getCompany(): CompanyDto | undefined {
    return this.company$.getValue();
  }
  onCompany(): Observable<CompanyDto | undefined> {
    return this.company$.asObservable();
  }
}
